import type {
  TranscriptEffect,
  TranscriptPlacement,
  TranscriptSplit,
} from 'creatomate';

export type KaraokeConfig = {
  id: string;
  width: string;
  font_size: string;
  font_weight: string;
  fill_color: string;
  background_color: string | null;
  background_align_threshold?: string;
  background_border_radius?: string;
  text_wrap: boolean;
  x_alignment: string;
  x: string | null;
  y: string;
  line_height: string;
  font_family: string;
  font_style?: string;
  text_transform?: string;
  stroke_color: string;
  stroke_width: string;
  letter_spacing?: string;
  animations: any[];
  // maxCharactersPerElement: number; hardcoded in produceKaraokeElements
  hideComma: boolean;
  hidePeriod: boolean;
  hideFillers: boolean;
  //   instagramEffect: boolean;
  //   instagramLines: keyof typeof InstagramAnimationLines;
  language: 'original' | 'english';
  shadow_color?: string | null;
  shadow_blur?: number | null;
  shadow_x?: number | null;
  shadow_y?: number | null;
  //   variablePositionings?: VariablePositionings;
  transcript_effect?: TranscriptEffect;
  transcript_split?: TranscriptSplit;
  transcript_placement?: TranscriptPlacement;
  transcript_maximum_length?: number | null;
  transcript_color?: string;
};

export type VariablePositioningValues = {
  x: string | null;
  y: string | null;
  x_alignment: string;
};

export type VariablePositioningKeys = 'stacked-1-1' | 'stacked-1-3';

export type VariablePositionings = Record<
  VariablePositioningKeys,
  VariablePositioningValues
>;

export const DEFAULT_EDITOR_KARAOKE_CONFIG: Omit<KaraokeConfig, 'id'> = {
  width: '76%',
  font_size: '3.333vh',
  font_weight: '400',
  fill_color: 'white',
  background_color: 'transparent',
  background_align_threshold: '0%',
  background_border_radius: '0%',
  text_wrap: true,
  x_alignment: '50%',
  y: '86%',
  x: '50%',
  line_height: '125%',
  font_family: 'Anton',
  font_style: 'normal',
  stroke_color: 'rgba(0, 0, 0, 1)',
  stroke_width: '1 vmin',
  letter_spacing: '50%',
  animations: [] as any[],
  hideComma: false,
  hidePeriod: false,
  hideFillers: false,
  language: 'original',
  shadow_color: null,
  shadow_blur: null,
  shadow_x: null,
  shadow_y: null,
  text_transform: 'uppercase',
};
